import { render, staticRenderFns } from "./consumer_notice.vue?vue&type=template&id=276c8164&scoped=true"
import script from "./consumer_notice.vue?vue&type=script&lang=js"
export * from "./consumer_notice.vue?vue&type=script&lang=js"
import style0 from "./consumer_notice.vue?vue&type=style&index=0&id=276c8164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276c8164",
  null
  
)

export default component.exports